import { render, staticRenderFns } from "./dialog-pro-add.vue?vue&type=template&id=f6fd1942&scoped=true"
import script from "./dialog-pro-add.vue?vue&type=script&lang=js"
export * from "./dialog-pro-add.vue?vue&type=script&lang=js"
import style0 from "./dialog-pro-add.vue?vue&type=style&index=0&id=f6fd1942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fd1942",
  null
  
)

export default component.exports